import { Loader } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import React from 'react';
import RateGroup from './rateGroup';

/**
 * Get all groups and for each group display groups and rates in this group
 * @param groups: array containing groups and rates
 *      [{
 *          id: GroupId,
 *          name: "Group Name",
 *          rates:[{ id: RateIdContainingGroup, name:"Rates Name Containing Group"}, {...}]
 *      }]
 * @param groupsChecked: Array of group id checked
 * @param onGroupChecked: action to perform on check group
 * @param ratesChecked: Array of rates checked
 * @param onRateChecked: action to perform on check rate
 */
export default function GroupedRates({ groups, groupsChecked, onGroupChecked, ratesChecked, onRateChecked }) {
    if (!groups) {
        return <Loader />;
    }

    return groups.map(group => (
        <RateGroup
            key={group.id}
            className="category-rules"
            group={group}
            onGroupChecked={onGroupChecked}
            isSelected={groupsChecked.includes(group.id)}
            groupsChecked={groupsChecked}
            ratesChecked={ratesChecked}
            onRateChecked={onRateChecked}
        />
    ));
}

GroupedRates.propTypes = {
    groups: PropTypes.array.isRequired,
    groupsChecked: PropTypes.array.isRequired,
    onGroupChecked: PropTypes.func.isRequired,
    ratesChecked: PropTypes.array.isRequired,
    onRateChecked: PropTypes.func.isRequired
};
